import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

const QuotesPage = lazyRouteComponent(() => import("@modules/quotes/pages/QuotesPage"), "QuotesPage");

export function getRoutes(parentRoute) {
  return [createRoute({ getParentRoute: () => parentRoute, path: "/quotes", component: QuotesPage })];
}
